export const I18N_KEYS = {
    HOMEPAGENAME: "homePage_name",
    ABOUTPAGENAME: "aboutPage_name",
    DIGNATARIESPAGENAME: "dignatariesPage_name",
    TOPSTUDENTPAGENAME: "topstudentPage_name",
    TOPTEACHERPAGENAME: "teacherPage_name",
    GALERYPAGENAME: "galleryPage_name",
    CONTACTUSPAGENAME: "contactustPage_name",
    ABOUTUSTITLE: "aboutus_title",
    DIGNATARIESTITLE: "dignataries_title",
    INFRASTRUCTURETITLE: "infrastructure_title",
    APPROACHTITLE: "approach_title",
    TOPTEACHERTITLE: "topTeacher_title",
    TOPSTUDENTTITLE: "topStudent_title",
    CAMPUSPHOTOTITLE: "campusPhoto_title",
    GALLERYTITLE: "gallery_title",
    FEATURETITLE: "feature_title",
    ACHIEVEMENTTITLE: "achievements_title",
    CONTACTUSTITLE1: "contact_us_title1",
    CONTACTUSTITLE2: "contact_us_title2",
    FOOTERLINKTITLE: "footerLink_title",
    CAMPUSVISITPROMPT: "campus_visit_prompt",
    VIEWSTUDENTBUTTON: "view_student_button",
    VIEWTEACHERBUTTON: "view_teacher_button",
    VISITGALLERYBUTTON: "visit_gallery_button",
    SENDMESSAGEBUTTON: "send_message_button",
    ADDRESS: "address",
    PHONE: "phone",
    EMAIL: "email",
    WORKINGHOURS: "working_hours",
    HONORS: "honors",
    STUDENTS: "students",
    STAFF: "staff",
    YEARSOFEXP: "years_of_Experience",
    STUDENTINMBBS: "students_admitted_to_MBBS",
    STUDENTINJEE: "students_qualified_for_JEE_advanced",
    CONTACTUSINFO: "contact_us_info",
    NAME: "name",
    SUBJECT: "subject",
    MESSAGE: "message",
    YOURMAIL: "your_mail",
    PAGENOTFOUND: "page_not_found",
    PAGENOTFOUNDMSG: "page_not_found_msg",
    LOOKFOR: "look_for_page",
    TEACHEREXP: "teacher_exp",
    TEACHERSPECIALIZATION: "teacher_specialization",
    VIEWPROFILE: "teacher_profile",
    TEACHERQUALIFICATION: "teacher_qualification",
    ABOUT: "teacher_about",
    CLASS: "class",
    PERCENTAGE: "percentage",
    ACHIEVEMENT: "achievement",
    OVERALLPER: "overall_percentage",
    FOOTERRIGHTS: "footer_rights",
    DOWNLOAD: "download_brochure",
    VIEWIMG:"view_img"
}